var render = function () {
  var _vm$festa$section2$tx, _vm$festa$section2$tx2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "text": "유통 ∙ 물류 ∙ IT기업의 협업 연계를 통한 성장과 유통산업의 혁신 성장을 이끄는 스타트업 생태계 구축을 추구합니다.",
            "src": "/images/sub/sub-visual-pitching-festa.jpg"
          },
          scopedSlots: _vm._u([{
            key: "titleContents",
            fn: function fn() {
              return [_c('div', {
                staticClass: "sub-visual__tit-wrap mt-n20px"
              }, [_c('h2', {
                staticClass: "sub-visual__tit"
              }, [_c('span', {
                staticClass: "font-size-lg-100 font-weight-bold"
              }, [_vm._v("e")]), _vm._v("커머스피칭페스타 소개")])])];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_vm.festa ? [_c('page-section', {
    staticClass: "page-section--first",
    attrs: {
      "title": "행사소개"
    }
  }, [_c('div', {
    staticClass: "tit-wrap pb-0"
  }, [_c('h3', {
    staticClass: "tit tit--xl",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm$festa$section2$tx = _vm.festa.section2.txt[0]) === null || _vm$festa$section2$tx === void 0 ? void 0 : _vm$festa$section2$tx.replace(/\n/g, '<br/>'))
    }
  })]), _c('div', {
    staticClass: "txt txt--lg txt--dark",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "200"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm$festa$section2$tx2 = _vm.festa.section2.txt[1]) === null || _vm$festa$section2$tx2 === void 0 ? void 0 : _vm$festa$section2$tx2.replace(/\n/g, '<br/>'))
    }
  })])]), _c('div', {
    staticClass: "page-section__bg",
    staticStyle: {
      "background-image": "url(/images/common/grey-bg.png)"
    }
  })]), _c('page-section', {
    staticClass: "pb-0",
    attrs: {
      "title": "행사개요"
    }
  }, [_c('table-primary', _vm._l(_vm.festa.section3.table.list, function (item, index) {
    return _c('table-primary-row', {
      key: index,
      scopedSlots: _vm._u([{
        key: "title",
        fn: function fn() {
          return [_c('span', {
            domProps: {
              "innerHTML": _vm._s(item.title.replace(/\n/g, '<br />'))
            }
          })];
        },
        proxy: true
      }, {
        key: "text",
        fn: function fn() {
          return [_c('p', {
            domProps: {
              "innerHTML": _vm._s(item.input.replace(/\n/g, '<br />'))
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1)], 1), _c('page-section', {
    staticClass: "pb-0",
    attrs: {
      "title": "프로세스"
    }
  }, [_c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/sub/pitching-festa/process-img-mo.png",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }), _c('v-img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "src": "/images/sub/pitching-festa/process-img.png",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  })], 1), _c('page-section', {
    attrs: {
      "title": "개최 성과"
    },
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.festa.section4.txt[0])
          }
        })];
      },
      proxy: true
    }], null, false, 2705143378)
  }, [_c('v-row', {
    staticClass: "row--lg",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "aspect-ratio": 104 / 102,
      "max-width": "104",
      "src": "/images/sub/pitching-festa/perfomance-icon.png"
    }
  }), _c('div', {
    staticClass: "mt-16px mt-md-20px"
  }, [_c('div', {
    staticClass: "tit tit--xs mb-12px"
  }, [_vm._v("발굴기업")]), _c('div', {
    staticClass: "d-flex align-center tit tit--xs"
  }, [_vm._v("총"), _c('strong', {
    staticClass: "tit--xl px-6px px-md-10px"
  }, [_vm._v("203")]), _vm._v("개사 +")])])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "",
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "aspect-ratio": 104 / 102,
      "max-width": "104",
      "src": "/images/sub/pitching-festa/perfomance-icon2.png"
    }
  }), _c('div', {
    staticClass: "mt-16px mt-md-20px"
  }, [_c('div', {
    staticClass: "tit tit--xs mb-12px"
  }, [_vm._v("투자유치금액")]), _c('div', {
    staticClass: "d-flex align-center tit tit--xs"
  }, [_vm._v("총"), _c('strong', {
    staticClass: "tit--xl px-6px px-md-10px"
  }, [_vm._v("1,883")]), _vm._v("억원")])])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "aspect-ratio": 116 / 100,
      "max-width": "116",
      "src": "/images/sub/pitching-festa/perfomance-icon3.png"
    }
  }), _c('div', {
    staticClass: "mt-16px mt-md-20px"
  }, [_c('div', {
    staticClass: "tit tit--xs mb-12px"
  }, [_vm._v("협업 연계")]), _c('div', {
    staticClass: "d-flex align-center tit tit--xs"
  }, [_vm._v("총"), _c('strong', {
    staticClass: "tit--xl px-6px px-md-10px"
  }, [_vm._v("50")]), _vm._v("건 +")])])], 1)])])], 1)], 1), _c('page-section', {
    staticClass: "grey lighten-5",
    attrs: {
      "title": "프로그램"
    },
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.festa.section5.txt[0])
          }
        })];
      },
      proxy: true
    }], null, false, 831983955)
  }, [_c('div', {
    staticClass: "program-container"
  }, [_c('v-row', {
    staticClass: "row--large"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/pitching-festa/program01.png",
      "alt": "이미지"
    }
  })]), _c('h4', {
    staticClass: "program-title"
  }, [_vm._v("피칭데이")]), _c('p', {
    staticClass: "desc"
  }, [_vm._v(" 피칭을 통한 우수기업 시상 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/pitching-festa/program02.png",
      "alt": "이미지"
    }
  })]), _c('h4', {
    staticClass: "program-title"
  }, [_vm._v("전시 지원")]), _c('p', {
    staticClass: "desc"
  }, [_vm._v(" 디지털유통대전 내 스타트업 제품과"), _c('br'), _vm._v(" 서비스등을 소개할 수 있는 부스전시공간 마련 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/pitching-festa/program03.png",
      "alt": "이미지"
    }
  })]), _c('h4', {
    staticClass: "program-title"
  }, [_vm._v("네트워킹")]), _c('p', {
    staticClass: "desc"
  }, [_vm._v(" 스타트업과 유관 기업들의"), _c('br'), _vm._v(" 미팅자리 마련 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/pitching-festa/program04.png",
      "alt": "이미지"
    }
  })]), _c('h4', {
    staticClass: "program-title"
  }, [_vm._v(" 풀필먼트 사업 연계 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/pitching-festa/program05.png",
      "alt": "이미지"
    }
  })]), _c('h4', {
    staticClass: "program-title"
  }, [_vm._v(" 기술 실증 지원 ")])])]), _c('v-col', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/images/sub/pitching-festa/program06.png",
      "alt": "이미지"
    }
  })]), _c('h4', {
    staticClass: "program-title"
  }, [_vm._v(" 데이터 활용 지원 ")]), _c('p', {
    staticClass: "desc"
  }, [_vm._v(" 유통데이터를 활용한 신서비스 개발"), _c('br'), _vm._v(" 및 사업화 지원 ")])])])], 1)], 1)]), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "title": "Partners"
    },
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.festa.section6.contents.frame2211.txt[0])
          }
        })];
      },
      proxy: true
    }], null, false, 753390487)
  }, [_vm._l(_vm.festa.section6.contents.frame2302.logoList, function (logoItems, row) {
    return [_c('v-row', {
      key: row,
      staticClass: "ma-n4px my-md-n20px"
    }, [_vm._l(logoItems, function (_ref, col) {
      var src = _ref.src,
        url = _ref.url;
      return [_c('v-col', {
        key: col,
        staticClass: "pa-4px py-md-20px",
        attrs: {
          "cols": "6",
          "sm": "4",
          "md": "3",
          "data-aos": "fade-up",
          "data-aos-delay": "100"
        }
      }, [_c('v-card', {
        attrs: {
          "tile": "",
          "flat": "",
          "href": url,
          "target": "_blank"
        }
      }, [_c('v-img', {
        attrs: {
          "contain": "",
          "height": _vm.$vuetify.breakpoint.mdAndDown ? '60' : '96',
          "src": src
        }
      })], 1)], 1)];
    }), _c('v-spacer')], 2)];
  })], 2)] : _vm._e(), _c('popup-layer')], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }